import { ru_RU } from './ru-RU';

// Export
export class UserModelI18N {
    constructor() {
        new ru_RU();
    }
}
